import React, {
  useState,
  useRef,
  useEffect,
  Fragment,
  useMemo,
  useCallback,
} from 'react'
import { useRouter } from 'next/router'
import SwiperCore, { SwiperOptions, Pagination } from 'swiper'
import Swiper from 'react-id-swiper'
import Layout from '@/components/Layout'
import ButtonLink from '@/components/ButtonLink'
import NewsList from '@/components/NewsList'
import styles from '@/styles/Home.module.scss'
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'
import { urlsheets, urlnotifications } from '@/lib/custom'
import { time } from '@/lib/util'
import {
  SHEETSTYPE,
  GETDATANOTIFICATIONSTYPE,
  SHEETTYPE,
  SHEETS01TYPE,
} from '@/types/Types'
import { useCustumHooksFetchAll } from '@/lib/useF'
import Loading from '@/components/Loading'
import CampaignComponents from '@/components/CampaignComponents'
import StampComponents from '@/components/StampComponents'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/app/store'
import { dialogPointReducer } from '@/features/dialogSlice'
import { dialogGroupSpotsState } from '@/features/dialogGroupSpotsSlice'
import Dialog from '@/components/Dialog'
import Link from 'next/link'
import { spotCheck } from '@/features/spotMapSlice'
import useSWR from 'swr'
import { originalUseSWR } from '@/lib/originalUseSWR'
import { urlsheets01 } from '@/lib/custom'

SwiperCore.use([Pagination])

type NotificationsBodyTYPE = {
  body: string
  createdAt: string
  endAt: string
  id: number
  isShow: boolean
  startAt: string
  status: number
  title: string
  updatedAt: string
}[]

const Home = () => {
  const ref = useRef(null)
  const dispatch = useDispatch()
  const router = useRouter()

  const [NotificationsState, setNotificationsState] =
    useState<NotificationsBodyTYPE>()
  const [isAvailable, setAvailable] = useState<boolean>(true)
  const [FetchSheetsState, setFetchSheetsState] = useState<SHEETSTYPE>()
  const [dialogContentState, setDialogContentState] = useState<SHEETTYPE>()
  const [swiperIndex, setSwiperIndex] = useState(1)

  const dataCampain = useSelector((state: RootState) => state.campain.campaign)
  const dialogPointSelector = useSelector(
    (state: RootState) => state.dialog.dialogPointState
  )

  const dialogGroupSpotsSelector = useSelector(
    (state: RootState) => state.dialogGroupSpots.boolean
  )
  const groupSpotsSelector = useSelector(
    (state: RootState) => state.dialogGroupSpots.spots
  )

  console.log(dataCampain)

  const [FetchNotificationState, setFetchNotificationState] =
    useState<GETDATANOTIFICATIONSTYPE>()

  const useFetch = useCustumHooksFetchAll([
    `${urlsheets}`,
    `${urlnotifications}`,
  ])

  const { data: SpotsSheetsState, error: SpotsSheetsStateError } =
    useSWR<SHEETS01TYPE>(`${urlsheets01}`, originalUseSWR, {
      revalidateOnFocus: false,
    })

  useEffect(() => {
    if (useFetch !== undefined) {
      useFetch
        .then((res) => {
          return res
        })
        .then((res) => {
          if (res !== undefined) {
            if (res.length === 0) {
              throw new Error('Whoops!')
            }

            setFetchSheetsState(res[0])
            setFetchNotificationState(res[1])
          }
        })
        .catch((err) => {
          useFetch
            .then((res) => {
              return res
            })
            .then((res) => {
              if (res !== undefined) {
                if (res.length === 0) {
                  throw new Error('Whoops!')
                }

                setFetchSheetsState(res[0])
                setFetchNotificationState(res[1])
              }
            })
            .catch((err) => {
              console.error({ err })
            })
        })
    }
  }, [useFetch])

  useEffect(() => {
    const notificationsArray = []

    if (FetchNotificationState !== undefined) {
      if (
        FetchNotificationState.notifications === null ||
        FetchNotificationState.notifications === undefined
      ) {
        setNotificationsState(notificationsArray)
      } else {
        /**
         * 表示件数の制限
         */
        for (let i = 0; i < 3; i++) {
          if (FetchNotificationState.notifications[i]) {
            notificationsArray.push(FetchNotificationState.notifications[i])
          }
        }

        setNotificationsState(notificationsArray)
      }
    }
  }, [FetchNotificationState])

  const params: SwiperOptions = useMemo(
    () => ({
      speed: 1000,
      centeredSlides: true,
      roundLengths: true,
      spaceBetween: 30,
      autoHeight: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 'auto',
        },
      },
      on: {
        slideChange: (swiper) => {
          setSwiperIndex(swiper.realIndex + 1)
        },
      },
    }),
    []
  )

  const popupAcquisitionStatus = useCallback((content: SHEETTYPE) => {
    dispatch(dialogPointReducer(false))
    setDialogContentState(content)
  }, [])

  useEffect(() => {
    if (FetchSheetsState !== undefined && NotificationsState !== undefined) {
      setAvailable(false)
      return
    }
  }, [FetchSheetsState, NotificationsState])

  const showCouponList = useCallback(() => {
    dispatch(spotCheck('coupon'))
    router.push({
      pathname: '/spot/',
    })
  }, [SpotsSheetsState])

  if (isAvailable === true) return <Loading />
  if (SpotsSheetsStateError) return <div>{''}</div>

  return (
    <Layout title="Topページ">
      <CampaignComponents />
      {NotificationsState.length !== 0 ? (
        <section className="c-shadow_top bg-white mt-8 pt-6 pb-10">
          <div className="l-inner">
            <h2 className="text-center text-h2 font-bold">お知らせ</h2>
            <div className="my-8">
              {NotificationsState &&
                NotificationsState.map((content, i) => {
                  return (
                    <Fragment key={i}>
                      <NewsList
                        link="/news/detail/"
                        time={time(content.startAt)}
                        text={content.title}
                        query={`${content.id}`}
                      />
                    </Fragment>
                  )
                })}
            </div>
            <ButtonLink
              text="お知らせ一覧へ"
              link="/news/"
              classname="font-bold"
            />
          </div>
        </section>
      ) : (
        ''
      )}
      <section className="my-8">
        <div className="l-inner">
          <h2 className="text-center text-h2 font-bold">
            {dataCampain.type === 1 && '獲得スタンプ'}
            {dataCampain.type === 2 && '総獲得ポイント'}
          </h2>

          {dataCampain.type === 2 && FetchSheetsState.sheets && (
            <div className="c-shadow mt-3 rounded-[4px] bg-[#fff] p-[10px] text-center">
              <p className="text-[80px] font-bold">
                {FetchSheetsState.sheets[0].earnedPoints}
                <span className="text-[30px] font-bold">pt</span>
              </p>
            </div>
          )}

          {console.log(FetchSheetsState)}
          {/* type === 1 : スタンプ, type === 2 : ポイント */}
          {dataCampain.type === 1 && (
            <div className="c-topSwiper relative mt-[18px]">
              <p className="c-topSwiper_fraction">
                {swiperIndex} /{' '}
                {FetchSheetsState.sheets &&
                  FetchSheetsState.sheets.slice(1).length}
              </p>
              <Swiper {...params} ref={ref}>
                {FetchSheetsState.sheets &&
                  FetchSheetsState.sheets.slice(1).map((content, i: number) => {
                    return (
                      <div
                        key={i}
                        className={`mt-[55px] ${styles.c_stamp_body}`}
                      >
                        <div className="relative">
                          <h2 className="px-3 text-center text-sm font-bold">
                            {content.name}
                          </h2>
                        </div>
                        <div className="mt-5 mr-3 flex items-center justify-end">
                          <div className={styles.c_stamp_len}>
                            <p>スタンプ獲得数</p>
                            <p className="ml-4">
                              {dataCampain.isRepeatStamp ? (
                                <>{content.hasCount}</>
                              ) : (
                                <>
                                  {content.hasCount} / {content.total}
                                </>
                              )}
                            </p>
                          </div>
                        </div>
                        <div
                          className={`flex flex-wrap ${styles.c_stamp_contents_wrap}`}
                        >
                          {content.stamps &&
                            content.stamps.map((contentStamp, i: number) => {
                              return (
                                <StampComponents
                                  key={i}
                                  query={contentStamp.spotId}
                                  hascount={contentStamp.hasCount}
                                  course={content.name}
                                  img={contentStamp.image}
                                  name={contentStamp.name}
                                  spots={contentStamp.spots}
                                  dataCampaign={dataCampain}
                                />
                              )
                            })}
                        </div>
                      </div>
                    )
                  })}
              </Swiper>
            </div>
          )}

          {dataCampain.type === 2 && (
            <div className="c-topSwiper relative mt-[25px]">
              <p className="c-topSwiper_fraction">
                {swiperIndex} /{' '}
                {FetchSheetsState.sheets &&
                  FetchSheetsState.sheets.slice(1).length}
              </p>
              <Swiper {...params} ref={ref}>
                {FetchSheetsState.sheets &&
                  FetchSheetsState.sheets.slice(1).map((content, i: number) => {
                    return (
                      <div
                        key={i}
                        className={`mt-[55px] ${styles.c_stamp_body}`}
                      >
                        <div className="relative">
                          <h2 className="px-3 text-center text-sm font-bold">
                            {content.name}
                          </h2>
                        </div>
                        <div className="mx-3 mt-5 text-center">
                          <p className="text-[14px]">コース累計獲得ポイント</p>
                          <p className="text-[48px] font-bold">
                            {content.earnedPoints}
                            <span className="text-[24px] font-bold">pt</span>
                          </p>
                        </div>

                        <p
                          className={styles.c_acquisitionStatus}
                          onClick={() => popupAcquisitionStatus(content)}
                        >
                          スポットごとの獲得状況
                        </p>
                      </div>
                    )
                  })}
              </Swiper>
            </div>
          )}
        </div>
      </section>
      {SpotsSheetsState &&
        SpotsSheetsState.sheets &&
        SpotsSheetsState.sheets.map((sheet, i) => {
          if (sheet.id !== 'coupon') return
          if (sheet.spots) {
            return (
              <div className="mb-12 text-center" key={i}>
                <button
                  type="button"
                  name="button"
                  className="c-button_min c_button_min04"
                  onClick={() => showCouponList()}
                >
                  クーポン一覧へ
                </button>
              </div>
            )
          }
        })}
      <Dialog
        title="スポットごとの獲得状況"
        selectorState={dialogPointSelector}
        dispatchAction={dialogPointReducer}
      >
        <ul className="mt-[25px]">
          {dialogContentState &&
            dialogContentState.stamps.map((stamp, i: number) => {
              return (
                <li key={i} className={styles.c_pointTableList}>
                  <table className={styles.c_pointTable}>
                    <tr>
                      <th>
                        <Link
                          href={{
                            pathname: '/spot/detail/',
                            query: {
                              query: stamp.spotId,
                              course: 'すべて',
                            },
                          }}
                        >
                          <a
                            className="text-[13px] font-semibold underline"
                            onClick={() => {
                              dispatch(dialogPointReducer(true))
                            }}
                          >
                            {stamp.name}
                          </a>
                        </Link>
                      </th>
                      <td className="text-[20px] font-bold">
                        {stamp.earnedPoints}
                        <span className="text-[16px]">pt</span>
                      </td>
                    </tr>
                    <tr>
                      <th className="text-[11px] font-light">
                        このスポットで獲得できるポイント
                      </th>
                      <td className="text-[16px] font-light">
                        {stamp.point}
                        <span className="text-[12px]">pt</span>
                      </td>
                    </tr>
                  </table>
                </li>
              )
            })}
        </ul>
      </Dialog>
      {/* スポットグループモダール */}
      <Dialog
        title="このスタンプを獲得できるスポット"
        titleSmall
        selectorState={dialogGroupSpotsSelector}
        dispatchAction={dialogGroupSpotsState}
      >
        <ul className="mt-[25px]">
          {groupSpotsSelector &&
            groupSpotsSelector.map((spot, i: number) => {
              return (
                <li key={i} className={styles.c_pointTableList}>
                  <table className={styles.c_pointTable}>
                    <tr>
                      <th className="py-[7.25px]">
                        <Link
                          href={{
                            pathname: '/spot/detail/',
                            query: {
                              query: spot.id,
                              course: 'すべて',
                            },
                          }}
                        >
                          <a
                            className="text-[13px] font-semibold underline"
                            onClick={() => {
                              dispatch(dialogGroupSpotsState(true))
                            }}
                          >
                            {spot.name}
                          </a>
                        </Link>
                      </th>
                    </tr>
                    <tr>
                      <th className="py-[3.75px] text-[11px] font-light">
                        {spot.address}
                      </th>
                    </tr>
                  </table>
                </li>
              )
            })}
        </ul>
      </Dialog>
    </Layout>
  )
}

export default Home
